// v5.4.0 · Dashboard: consumo de videollamadas por ANFITRIÓN (docente que abre la sala), minutos estándar de Agora.
import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Video } from "lucide-react";

// v5.6.1 · `month` (opcional, AAAA-MM): si se pasa, la tarjeta sigue ese mes y oculta su propio selector
// (así, dentro de Tecnología → Estado de videollamada, queda sincronizada con el consumo del plan).
export default function HostUsageCard({ month: monthProp }) {
  const controlled = monthProp !== undefined;
  const [d, setD] = useState(null);
  const [monthState, setMonth] = useState("");
  const month = controlled ? monthProp : monthState;
  useEffect(() => {
    api.get("/video/usage/by-host", { params: month ? { month } : {} }).then(({ data }) => { setD(data); if (!controlled && !monthState) setMonth(data.month); }).catch(() => setD({ items: [], total_standard_minutes: 0 }));
  }, [month]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const max = Math.max(1, ...d.items.map((i) => i.std));
  return (
    <div className="bg-white border border-[#E1E5F0] rounded-lg p-6" data-testid="host-usage">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-[#6E7591]">Videollamadas</p>
          <h3 className="font-display text-lg font-bold tracking-tight text-[#1F2547] mt-0.5 inline-flex items-center gap-2"><Video size={16} className="text-[#05A859]" /> Consumo por anfitrión</h3>
        </div>
        {!controlled && <input type="month" value={month} onChange={(e) => setMonth(e.target.value)} data-testid="host-usage-month" className="px-3 py-1.5 text-sm border border-[#E1E5F0] rounded-md" />}
      </div>
      {d.items.length === 0 ? (
        <p className="text-sm text-[#6E7591] py-6 text-center" data-testid="host-usage-vacio">Sin consumo registrado en este mes.</p>
      ) : (
        <>
          <p className="text-xs text-[#6E7591] mt-2">Total: <b className="text-[#1F2547]">{Math.round(d.total_standard_minutes).toLocaleString("es-MX")}</b> min estándar</p>
          <ul className="mt-3 space-y-3">
            {d.items.map((h) => (
              <li key={h.teacher_id || h.teacher_name} data-testid={`host-row-${h.teacher_id}`}>
                <div className="flex items-baseline justify-between gap-3">
                  <span className="text-sm font-bold text-[#1F2547] truncate">{h.teacher_name}</span>
                  <span className="text-xs text-[#6E7591] shrink-0">{h.std.toLocaleString("es-MX")} min · {h.share}%</span>
                </div>
                <div className="h-2 rounded-full bg-[#E1E5F0] overflow-hidden mt-1"><div className="h-full rounded-full bg-[#05A859]" style={{ width: `${(h.std / max) * 100}%` }} /></div>
                <p className="text-[11px] text-[#6E7591] mt-0.5">{h.classes} clase(s) · {h.participants} entradas · {h.video} min con video · {h.audio} solo audio</p>
              </li>
            ))}
          </ul>
        </>
      )}
      <p className="text-[11px] text-[#8A91AB] mt-3">{d.note}</p>
    </div>
  );
}
